import React, { useContext } from "react";
import { IconButton, ListActionButtonProps, Stack } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { OnPremOrderListingContext } from "../context/OnPremOrderListingContext";
import { OnPremOrderListingItem } from "../OnPremOrderListingItem";

type PinOrderListingButtonProps = ListActionButtonProps<OnPremOrderListingItem>;

export const PinOnPremOrderListingButton: React.VFC<PinOrderListingButtonProps> = ({
    item
}: PinOrderListingButtonProps) => {
    const { togglePinnedOnPremOrder } = useContext(OnPremOrderListingContext);

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdReadWrite]}>
            <Stack horizontal verticalAlign="center">
                <IconButton
                    iconProps={{ iconName: item.isPinned ? "PinnedSolid" : "Pinned" }}
                    styles={{
                        iconButton: {
                            flexContainer: { alignItems: "flex-start" }
                        }
                    }}
                    tooltipContent={`${item.isPinned ? "Unpin" : "Pin"} order`}
                    testId="pin-list-button"
                    onClick={() => togglePinnedOnPremOrder(item.id)}
                />
            </Stack>
        </AuthorizationWrapper>
    );
};
